import React, { useCallback, useEffect, useState } from "react";
import { useHttp } from "../../../hooks/http.hook";
import { FaArrowUp, FaRandom, FaBan } from "react-icons/fa";

const RandomHolderToggle = () => {
  const { request, loading } = useHttp();
  const [mode, setMode] = useState("DESC"); // дефолт

  const getStatus = useCallback(async () => {
    try {
      const data = await request(`/api/utils/random-holder`, "GET");
      if (data.success === true) {
        setMode(data.holder_state || "DESC");
      }
    } catch (e) {
      console.log(e);
    }
  }, [request]);

  const setStatusIsActive = useCallback(
    async (newMode) => {
      try {
        const data = await request(`/api/utils/random-holder-toggle`, "POST", {
          enabled: newMode,
        });
        if (data.success === true) {
          setMode(newMode);
        }
      } catch (e) {
        console.log(e);
      }
    },
    [request]
  );

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  const getButtonProps = () => {
    switch (mode) {
      case "ASC":
        return {
          color: "green",
          label: "By New",
          icon: <FaArrowUp size={50} color="green" />,
        };
      case "RAND":
        return {
          color: "blue",
          label: "Randomly",
          icon: <FaRandom size={50} color="blue" />,
        };
      case "DESC":
      default:
        return {
          color: "red",
          label: "Default",
          icon: <FaBan size={50} color="red" />,
        };
    }
  };

  const btn = getButtonProps();

  // Циклічне перемикання режимів
  const handleClick = () => {
    let nextMode;
    if (mode === "ASC") nextMode = "RAND";
    else if (mode === "RAND") nextMode = "DESC";
    else nextMode = "ASC";
    setStatusIsActive(nextMode);
  };

  return (
    <div
      style={{ display: "flex", alignItems: "center", marginLeft: "20px" }}
      title="Режим відправки лідів"
    >
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
        aria-label="Toggle Holder"
      >
        <div style={{ filter: `drop-shadow(0 0 3px ${btn.color})` }}>
          {btn.icon}
        </div>
        <span>{loading ? "Loading..." : btn.label}</span>
      </button>
    </div>
  );
};

export default RandomHolderToggle;
